import { API_URL } from "constants/environment";
import { createApi } from "@reduxjs/toolkit/query/react";
import { ApiResponse } from "schemas/api";
import { axiosBaseQuery } from "utils";
import {
  CheckUsernamePayload,
  LoginPayload,
  PasswordResetPayload,
  ProfileChangePayload,
  RegisterPayload,
  SendVerificationCodePayload,
  VerifyAccountPayload,
} from "./interface";

export const authApi = createApi({
  reducerPath: "authApi",
  baseQuery: axiosBaseQuery({ baseUrl: `${API_URL}/` }),
  endpoints: (builder) => ({
    login: builder.mutation<ApiResponse, LoginPayload>({
      query: (credentials) => ({
        url: "user/auth/login",
        method: "POST",
        body: credentials,
      }),
    }),
    register: builder.mutation<ApiResponse, RegisterPayload>({
      query: (credentials) => ({
        url: "user/auth/register",
        method: "POST",
        body: credentials,
      }),
    }),
    verifyAccount: builder.mutation<ApiResponse, VerifyAccountPayload>({
      query: (credentials) => ({
        url: `user/auth/verify-user-account-sms`,
        method: "POST",
        body: credentials,
      }),
    }),
    resendVerifyToken: builder.mutation<
      ApiResponse,
      SendVerificationCodePayload
    >({
      query: (credentials) => ({
        url: `user/auth/resend-token`,
        method: "POST",
        body: credentials,
      }),
    }),
    requestPasswordReset: builder.mutation<
      ApiResponse,
      SendVerificationCodePayload
    >({
      query: (credentials) => ({
        url: "user/auth/password-reset-request",
        method: "POST",
        body: credentials,
      }),
    }),
    changePassword: builder.mutation<ApiResponse, PasswordResetPayload>({
      query: (credentials) => ({
        url: "user/auth/password-reset",
        method: "POST",
        body: credentials,
      }),
    }),
    checkUsername: builder.mutation<ApiResponse, CheckUsernamePayload>({
      query: (credentials) => ({
        url: `user/auth/check-username`,
        method: "POST",
        body: credentials,
      }),
    }),
    get: builder.mutation<ApiResponse, LoginPayload>({
      query: (credentials) => ({
        url: "user/auth/login",
        method: "POST",
        body: credentials,
      }),
    }),
  }),
});

export const {
  useLoginMutation,
  useRegisterMutation,
  useVerifyAccountMutation,
  useResendVerifyTokenMutation,
  useRequestPasswordResetMutation,
  useChangePasswordMutation,useCheckUsernameMutation
} = authApi;
